var map = {
	"./en": [
		104
	],
	"./en.js": [
		104
	],
	"./en.json": [
		396
	],
	"./index": [
		130
	],
	"./index.js": [
		130
	],
	"./zh": [
		190,
		0
	],
	"./zh.js": [
		190,
		0
	],
	"./zh.json": [
		997,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 994;


//////////////////
// WEBPACK FOOTER
// ./src/langs lazy ^\.\/.*$
// module id = 994
// module chunks = 3